// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 72016 ? "fc22d32c" : chunkId) + "." + {"29438":"d5e5319bd461dd83","31156":"661ad4f256613022","53348":"95c82ef8bab21e14","72016":"7418f537f4cd4b02"}[chunkId] + ".js";
};